import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import Typography from '@mui/material/Typography';
import { Stack, useTheme } from '@mui/material';
import { AxisConfig } from '@mui/x-charts/models';
import { IBarChartPanel } from '../Dashboard.model';
import { LayoutItem } from 'react-grid-layout';

interface BarChartPanelProps {
  panel: IBarChartPanel;
  layout?: LayoutItem | undefined;
}

const valueFormatter: AxisConfig['valueFormatter'] = (value, { location }) => {
  if (location === 'tick') {
    return value[0];
  }
  return value;
};

export default function BarChartPanel(props: BarChartPanelProps) {
  const { panel } = props;
  const { title, subtitle, dataset, dataKey, xAxisKey } = panel;
  const theme = useTheme();

  return (
    <Stack
      direction="column"
      width={'100%'}
      height={'100%'}
      sx={{ overflow: 'hidden' }}
    >
      <Stack direction="column" alignItems="flex-start" width={'100%'}>
        <Typography variant="body1" fontWeight={800} fontSize={'0.8em'}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" fontSize={'0.6em'}>
            {subtitle}
          </Typography>
        )}
      </Stack>
      <Stack width={'100%'} height={'100%'} sx={{ flexGrow: 1, minHeight: 0 }}>
        <BarChart
          dataset={dataset}
          series={[{ dataKey, color: theme.palette.primary.main }]}
          margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
          borderRadius={4}
          xAxis={[
            {
              dataKey: xAxisKey,
              scaleType: 'band',
              valueFormatter,
              disableTicks: true,
            },
          ]}
          yAxis={[{ position: 'none' }]}
        />
      </Stack>
    </Stack>
  );
}
